import { Modal, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

type ReviewAccountsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  accountsToReviewCount: number;
};

export const ReviewAccountsModal = ({ isOpen, onClose, accountsToReviewCount }: ReviewAccountsModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      testId="review-accounts-modal"
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage(MESSAGES.reviewAccountsModalTitle)}
      size="small"
    >
      <Text textWrap="pretty">
        {intl.formatMessage(MESSAGES.reviewAccountsModalBody, { count: accountsToReviewCount })}
      </Text>
    </Modal>
  );
};
